import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";

export const Timer = ({
  startDate,
  expectedEndDate,
}: {
  startDate: DateTime;
  expectedEndDate?: DateTime;
}) => {
  const [refDate, setRefDate] = useState(DateTime.now);

  useEffect(() => {
    // Function to update the timer every second
    const updateTimer = () => {
      setRefDate(DateTime.now());
    };

    // Set up the interval to update the timer every second
    const intervalId = setInterval(updateTimer, 1000);

    return () => clearInterval(intervalId);
  }, []); // Empty dependency array means this effect runs once after the initial render

  const formattedDate = refDate.diff(startDate).toFormat("h:mm:ss");

  return (
    <div>
      {formattedDate}
      {expectedEndDate !== undefined ? (
        <>
          <br />→ {expectedEndDate.toLocaleString(DateTime.DATETIME_SHORT)}
        </>
      ) : null}
    </div>
  );
};
